import {
  Stack,
  Text,
  Icon,
  InlineStack,
  Panel,
  PanelSection,
  Tooltip,
  TooltipContent,
} from '@customerio/pluma-components/react';
import type { ComponentProps } from 'react';

interface StatCardProps {
  icon: ComponentProps<typeof Icon>['name'];
  label: string;
  tooltip: string;
  value: string;
  unit: string;
}

export function StatCard({ icon, label, tooltip, value, unit }: StatCardProps) {
  return (
    <Panel>
      <PanelSection>
        <Stack>
          <Icon name={icon} size="sm" color="subtle" />
          <InlineStack gap="050" pt="300" alignBlock="center">
            <Text size="s" color="subtle">
              {label}
            </Text>
            <Tooltip>
              <Icon name="help" size="xs" color="subtle" />
              <TooltipContent>{tooltip}</TooltipContent>
            </Tooltip>
          </InlineStack>
          <InlineStack gap="050" alignBlock="baseline">
            <Text size="l" weight="semibold">
              {value}
            </Text>
            <Text size="s" color="subtle">
              {unit}
            </Text>
          </InlineStack>
        </Stack>
      </PanelSection>
    </Panel>
  );
}
